/**
 * In-memory CSRF token store.
 *
 * Two scopes share the module: the admin cookie session and the
 * end-user cookie session each carry their own double-submit token.
 * The client picks a scope per-request based on path prefix; the
 * `admin` and `user` shapes are intentionally identical so the call
 * site is a single `getCsrfToken(scope)` lookup.
 */

export type CsrfScope = 'admin' | 'user';

const tokens: Record<CsrfScope, string | null> = {
  admin: null,
  user: null,
};

export function setCsrfToken(token: string | null, scope: CsrfScope = 'admin'): void {
  tokens[scope] = token;
}

export function getCsrfToken(scope: CsrfScope = 'admin'): string | null {
  return tokens[scope];
}

export function clearCsrfToken(scope: CsrfScope = 'admin'): void {
  tokens[scope] = null;
}
